/** Uploads an image (logo/background/category icon) directly to S3 via a presigned URL, returns the stored key. */
export async function uploadLsImage({ file, token }) {
  const urlResp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/getUploadUrl`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      currentTheme: "learning-style",
      kind: "lsimage",
      fileName: file.name,
    }),
  });

  if (!urlResp.ok) {
    const err = await urlResp.json().catch(() => ({}));
    throw new Error(err.message || "Failed to get upload URL");
  }

  const { uploadUrl, key, contentType } = await urlResp.json();

  const putResp = await fetch(uploadUrl, {
    method: "PUT",
    headers: { "Content-Type": contentType },
    body: file,
  });

  if (!putResp.ok) {
    throw new Error("Failed to upload image to storage");
  }

  return key;
}
